export default "__VITE_ASSET__EjxckxnT__"